import {Card, Grid, Paper, Typography} from "@material-ui/core";
import Carousel from 'react-material-ui-carousel'

import conference1 from "../../common/images/conference/conf1.jpg";
import conference2 from "../../common/images/conference/conf2.jpg";
import conference3 from "../../common/images/conference/conf3.jpg";

const Item = (props) => (
  <Paper style={{ border: '1px solid black', backgroundImage: `url(${props.item.img})`, backgroundSize: 'cover', backgroundPosition: props.item.position, height: '400px' }}>
    <h2>{props.item.name}</h2>
    <p>{props.item.description}</p>
  </Paper>
);

const Example = (props) => {
  const items = [
    {
      // name: "Random Name #1",
      // description: "Probably the most random thing you have ever seen!",
      img: conference1,
      position: 'center',
    },
    {
      // name: "Random Name #2",
      // description: "Hello World!",
      img: conference2,
      position: 'center',
    },
    {
      img: conference3,
      position: 'center'
    }
  ]

  return (
    <Carousel
      animation="slide"
    >
      {
        items.map( (item, i) => <Item key={i} item={item} /> )
      }
    </Carousel>
  )
}

const ConferenceRoom = () => {
  return (
    <div style={{ marginTop: '60px' }}>
      <Typography variant="h4" style={{ color: 'white' }}>Banquet/Conference Room</Typography>
      <Card style={{ padding: '20px' }}>
        <Grid container direction="row" justify="space-around">
          <Grid item xs={12} sm={12} md={5}>
            <div style={{ paddingTop: '20px' }}>
              <Typography variant="body1">We have a conference room that is available to be reserved.</Typography>
              <Typography variant="body1">Some other information can go here about the conference room.</Typography>
              <Typography variant="body1">Perfect for:
              <ul style={{ marginTop: 0 }}>
                <li>Birthday Parties</li>
                <li>Work Outings</li>
                <li>Family Gatherings</li>
                <li>Presentations</li>
              </ul>
              </Typography>
              <Typography variant="body1" style={{ paddingBottom: '10px' }}>Stop by or give us a call today to make your reservation!</Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <div>
              <Example />
            </div>
          </Grid>
        </Grid>
      </Card>
    </div>
  );
};

export default ConferenceRoom;
